module.exports = __webpack_public_path__ + "static/media/zara.9d25b85f.png";